<div class="rows">
    @if (plan || equipment || hasAccessories) {
        <div class="row">
            <div class="has-background-grey-fade">
                <div class="columns is-desktop is-multiline">
                    @if (plan) {
                        <div class="column subscription-block-separator">
                            <checkout-subscription-block [quoteIndex]="quoteIndex" />
                        </div>
                    }
                    @if (!plan) {
                        <div class="column">
                            <checkout-empty-cart-item
                                class="is-paddingless"
                                [isCartEmpty]="false"
                                [wallType]="'subscription'"
                                itemColor="tertiary"
                                itemIcon="tri-sim-card"
                                itemLabel="Besoin d'un forfait&nbsp;?"
                                ctaAriaLabel="Choisir un forfait"
                            />
                        </div>
                    }
                    @if (equipment) {
                        <div [ngClass]="{ 'equipment-block-separator': !plan }" class="right-block column">
                            <checkout-equipment-block [quoteIndex]="quoteIndex"></checkout-equipment-block>
                        </div>
                    }
                    @if (!equipment && mustSuggestMixedCard && !isMixedCart) {
                        <div class="right-block column">
                            <checkout-empty-cart-item
                                [isCartEmpty]="isQuoteEmpty || isBareCart"
                                [wallType]="'equipment'"
                                itemColor="tertiary"
                                itemIcon="tri-mobile"
                                itemLabel="Besoin d'un téléphone&nbsp;?"
                                ctaAriaLabel="Choisir un téléphone"
                            />
                        </div>
                    }
                    @if (isAccessoriesCart) {
                        <div class="right-block column">
                            <checkout-empty-cart-item
                                [isCartEmpty]="false"
                                [wallType]="'fai'"
                                itemColor="tertiary"
                                itemIcon="tri-box"
                                itemLabel="Besoin d'une box&nbsp;?"
                                ctaAriaLabel="Choisir une box"
                            />
                        </div>
                    }
                </div>
            </div>
        </div>
        @if ((isPreCrossSell && equipment) || hasAccessories) {
            <checkout-basic-crosssells [type]="crosssellTypes.ACCESSORY" [quoteIndex]="quoteIndex" />
        }
        @if ((isPreCrossSell && canShowOptions) || hasOptions) {
            <checkout-basic-crosssells
                [canAdd]="!isYamaCart"
                [type]="crosssellTypes.OPTION"
                [quoteIndex]="quoteIndex"
            />
        }
        @if ((plan && !isFai && sims?.length > 1) || isRenew) {
            <div [checkoutCy]="'block_sim'" class="row">
                @if (isRenew && (isSowo || isSimo)) {
                    @if (!simContext?.isCompatible) {
                        <ng-container>
                            <div class="alert has-body is-warning">
                                <span class="icon"><i class="tri-alert" aria-hidden="true"></i></span>
                                <div class="body">
                                    <div class="title is-level-5">
                                        Votre carte SIM actuelle semble incompatible avec votre nouveau mobile. Vous
                                        pourrez en commander une nouvelle dans votre Espace Client à la fin de votre
                                        souscription !
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    }
                } @else {
                    <checkout-sim
                        (simChoice)="onSimChoice($event)"
                        [hasPhone]="hasPhone"
                        [simContext]="simContext"
                        [selectedSim]="currentSimChoice"
                        [isRenew]="isRenew"
                        [isLoading]="isLoading"
                        [currentPlan]="currentPlan"
                    />
                }
            </div>
        }
    }
    @if (plan | isSmartTV) {
        <div class="row">
            <checkout-cms-block
                [battlefront]="false"
                blockId="mixte/zone_panier_bbox_smart_tv_1"
                [addIndexHtmlToUrl]="false"
            />
        </div>
    }
    @if (plan | isTabletRange) {
        <div class="row">
            <checkout-cms-block
                [battlefront]="false"
                blockId="ec/zone_panier_bbox_tablette"
                [addIndexHtmlToUrl]="false"
            />
        </div>
    }
    @if (plan | isIndiana) {
        <div class="row">
            <div class="box box-cart">
                <checkout-cms-block
                    [battlefront]="false"
                    blockId="checkout/indiana/bloc-reception"
                    [addIndexHtmlToUrl]="false"
                />
            </div>
        </div>
    }
    @if (isFtth3Clics && planPropertiesCmsKey) {
        <div class="row">
            <div checkoutCy="block-battlefront-ftth3clicks">
                <checkout-cms-block
                    [battlefront]="!isBankCart"
                    [blockId]="planPropertiesCmsKey"
                    [addIndexHtmlToUrl]="false"
                />
            </div>
        </div>
    }

    @if (showOfferPepites) {
        <div class="row">
            <checkout-offer-pepites [slug]="pepitesSlug" />
        </div>
    }

    @if (plan?.hasPorta && !isRenew) {
        <div class="row">
            <div checkoutCy="porta_block" class="row">
                <checkout-portability
                    [cartForm]="cartForm"
                    [plan]="plan"
                    [quoteIndex]="quoteIndex"
                    [isSubmitted]="isSubmitted"
                />
            </div>
        </div>
    }
    @if (plan && !isRenew) {
        <checkout-parental-control
            [cartForm]="cartForm"
            [plan]="plan"
            [quoteIndex]="quoteIndex"
            [isMobile]="isMobile"
        />
    }
    @if (equipment) {
        <div class="row">
            <div checkoutCy="insurances_block">
                <checkout-insurances [cartForm]="cartForm" [equipment]="equipment" [quoteIndex]="quoteIndex" />
            </div>
        </div>
    }
</div>
